import { LocalStorageGarageProvider } from './local-provider';
import { syncGlobalGarageIcon, syncGarageIcons } from './utils';

class LocalGarageImpl {
  #provider;

  constructor() {
    this.#provider = dsp.garage || new LocalStorageGarageProvider();
  }

  init() {
    syncGlobalGarageIcon();
    syncGarageIcons();
  }

  has(id) {
    return this.#provider.has(parseInt(id));
  }

  isEmpty() {
    return this.#provider.isEmpty();
  }

  empty() {
    return this.#provider.reset();
  }

  remove(id) {
    return this.#provider.remove(parseInt(id));
  }

  add(id) {
    return this.#provider.add(parseInt(id));
  }
}

export const LocalGarage = new LocalGarageImpl();
